import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appEqualWidthHeight]'
})
export class EqualWidthHeightDirective implements AfterViewInit {
  @Input() equalWith: string;

  constructor(private el: ElementRef) {
  }

  ngAfterViewInit() {

    if ((this.el.nativeElement.clientWidth && this.el.nativeElement.clientWidth > 0) 
    || (this.el.nativeElement.clientHeight && this.el.nativeElement.clientHeight > 0)) {
      if (this.equalWith === 'width') {
        this.el.nativeElement.style.height = `${this.el.nativeElement.clientWidth}px`;
      } else {
        this.el.nativeElement.style.width = `${this.el.nativeElement.clientHeight}px`;
      }
      this.el.nativeElement.style.opacity = `1`;
    } else {
      setTimeout(() => {
        this.ngAfterViewInit();
      }, 100);
    }

  }
}
